import React from 'react';
import { SvgIconProps } from '@mui/material';

import { SvgIcon } from '../svg-icon';

function HydraulicRamp({ ...props }: SvgIconProps): JSX.Element {
  return (
    <SvgIcon viewBox="0 0 16 16" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5 0.666656H7.83332C6.91665 0.666656 6.16665 1.41666 6.16665 2.33332V9.83332C6.16665 10.151 6.25671 10.4486 6.41255 10.7019L5.51063 12.55L0.874691 12.9556C0.553751 12.9837 0.316339 13.2666 0.344418 13.5875C0.372497 13.9085 0.655433 14.1459 0.976374 14.1178L5.62528 13.7111C5.93117 13.6843 6.16118 13.426 6.15777 13.124L7.04716 11.3016C7.2817 11.4281 7.54952 11.5 7.83332 11.5C7.83332 12.8833 8.94999 14 10.3333 14C11.7167 14 12.8333 12.8833 12.8333 11.5H14.5V0.666656ZM10.3333 12.3333C9.87499 12.3333 9.49999 11.9583 9.49999 11.5C9.49999 11.0417 9.87499 10.6667 10.3333 10.6667C10.7917 10.6667 11.1667 11.0417 11.1667 11.5C11.1667 11.9583 10.7917 12.3333 10.3333 12.3333Z"
      />
    </SvgIcon>
  );
}

export { HydraulicRamp };
